import { motion } from "framer-motion";
import React from "react";
import { useDispatch } from "react-redux";
import { handleModalClose } from "state/modalSlice";
import { StyledModal } from "./styled";

interface Props {
  children: React.ReactNode;
}

const Backdrop = ({ children }: Props) => {
  const AnimatedBackdrop = motion(StyledModal);
  const dispatch = useDispatch();

  return (
    <AnimatedBackdrop
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={() => dispatch(handleModalClose())}
    >
      {children}
    </AnimatedBackdrop>
  );
};

export default React.memo(Backdrop);
